/**
 * `HH:MM:SS`
 */
export function formatSecondsAsHms(totalSeconds: number) {
  const wholeSeconds = Math.trunc(totalSeconds);
  const hours = Math.floor(wholeSeconds / 3600);
  const minutes = Math.floor((wholeSeconds % 3600) / 60);
  const seconds = wholeSeconds % 60;

  return [hours, minutes, seconds].map(unit => String(unit).padStart(2, '0')).join(':');
}
